<style lang="scss" scoped></style>

<template>
    <div>
        <div class="row mb-24">
            <div class="d-flex align-items-center tag tag-sm mb-8 mr-8">
                <i v-html="svg('filter')" class="mr-8 filter-icon"></i
                ><small class="d-none d-md-block text-accent font-weight-light"
                    >Filter</small
                >
            </div>
            <div class="tag-row align-items-center">
                <div
                    class="tag-col d-flex"
                    v-for="category in locationCategories"
                    :key="category.id"
                >
                    <a
                        class="tag tag-sm mb-8"
                        :class="
                            activeCategories.includes(category.term_id)
                                ? 'tag-accent'
                                : 'tag-accent-light'
                        "
                        @click="toggleCategory(category)"
                        v-html="category.name"
                    ></a>
                </div>
            </div>
        </div>

        <div class="row mb-n24">
            <div
                v-for="location in visibleLocations"
                class="col-12 col-md-6 col-xl-4 mb-24"
            >
                <location-card :location="location"></location-card>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "pagePart.location-filter-row",

    props: {
        locations: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },

    data: () => ({
        locationCategories: [],
        activeCategories: []
    }),

    created() {
        let categories = [];
        this.locations.forEach(location => {
            if (
                location.location_categories &&
                location.location_categories.length > 0
            ) {
                categories = [...categories, ...location.location_categories];
            }
        });
        // remove duplicates by term_id
        categories = categories.filter(
            (category, index, self) =>
                index === self.findIndex(c => c.term_id === category.term_id)
        );
        this.locationCategories = categories;
    },

    methods: {
        toggleCategory(category) {
            if (this.activeCategories.includes(category.term_id)) {
                this.activeCategories = this.activeCategories.filter(
                    c => c !== category.term_id
                );
            } else {
                this.activeCategories = [...this.activeCategories, category.term_id];
            }
        }
    },

    computed: {
        visibleLocations() {
            if (this.activeCategories.length === 0) {
                return this.locations;
            }
            return this.locations.filter(location => {
                return location.location_categories && location.location_categories.some(category => {
                    return this.activeCategories.includes(category.term_id);
                });
            });
        }
    }
};
</script>
